import {FolderItemType} from '../folder/folder';

export type NotificationType = 'FOLDER_ITEM_CHANGED' | 'FOLDER_ITEM_REMOVED' | 'FOLDER_SHARED'
  | 'FOLDER_SHARE_ACCEPTED' | 'FOLDER_SHARE_DECLINED' | 'FOLDER_SHARE_LEFT';

export interface UserNotification {
  id: number;
  type: NotificationType;
  folderId: number;
  folderName: string;
  itemType: FolderItemType;
  itemTypeLabel: string;
  itemId: number;
  itemName: string;
  actorName: string;
  message: string;
  createdAt: string;
  read: boolean;
}

export interface UserNotificationPage {
  content: UserNotification[];
  totalElements: number;
  unreadCount: number;
}

/** per notification type; a GET returns every type, a PUT may leave out one of the maps and types */
export interface UserSettings {
  emailNotifications?: { [type in NotificationType]?: boolean };
  inAppNotifications?: { [type in NotificationType]?: boolean };
}

export type NotificationChannel = 'inApp' | 'email';

export const NOTIFICATION_TYPE_LABELS: { [type in NotificationType]: string } = {
  FOLDER_ITEM_CHANGED: 'Ein Eintrag in einer meiner Sammelmappen wurde bearbeitet',
  FOLDER_ITEM_REMOVED: 'Ein Eintrag in einer meiner Sammelmappen wurde gelöscht',
  FOLDER_SHARED: 'Eine Sammelmappe wurde mit mir geteilt',
  FOLDER_SHARE_ACCEPTED: 'Eine geteilte Sammelmappe wurde angenommen',
  FOLDER_SHARE_DECLINED: 'Eine geteilte Sammelmappe wurde abgelehnt',
  FOLDER_SHARE_LEFT: 'Eine geteilte Sammelmappe wurde von der empfangenden Person entfernt',
};
